import { VideoData, VideoOption } from './VideoData';
import { VideoSprite } from './VideoSprite';

export class VideoDataNull extends VideoData {
  get isCanBePlayed(): boolean {
    return true;
  }

  dispose(): void {}

  getSprite(): VideoSprite | null {
    return null;
  }

  preinit(): void {}

  play(_looped: boolean): void {}

  stop(): void {}

  pause(): void {}

  resume(): void {}

  reset(): void {}

  prepareToPlay(): Promise<void> {
    return Promise.resolve();
  }

  get videoOptions(): VideoOption[] {
    return [];
  }

  clone(): VideoData {
    return new VideoDataNull();
  }
}
